// Recent AI searches — a small localStorage list of the user's last queries and
// the results URL each resolved to. Clicking a recent navigates straight to its
// stored URL (no need to re-interpret), matching how suggestions work.

export interface RecentAiSearch {
  /** The text the user searched (display + de-dupe key). */
  query: string;
  /** The results URL this query resolved to. */
  url: string;
}

const STORAGE_KEY = 'ai_search_recent';
const MAX_ITEMS = 6;

export function getRecentAiSearches(): RecentAiSearch[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (i): i is RecentAiSearch =>
          i && typeof i.query === 'string' && typeof i.url === 'string' && i.query.trim() !== '',
      )
      .slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

export function saveRecentAiSearch(item: RecentAiSearch): void {
  if (typeof window === 'undefined') return;
  const query = item.query.trim();
  if (!query || !item.url) return;
  try {
    const existing = getRecentAiSearches().filter(
      i => i.query.trim().toLowerCase() !== query.toLowerCase(),
    );
    const next = [{ query, url: item.url }, ...existing].slice(0, MAX_ITEMS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Best-effort — a full/blocked localStorage just means no recent history.
  }
}
